import { useI18n } from 'vue-i18n'
import useFormatters from '@/composables/useFormatters'
import useBlProviders from '../providers/useBlProvider'
import FieldsDt from '@/services/dataTransferModules/fieldsDt'

export default function useFields() {
	const fieldsDt = new FieldsDt()
	const { t: $t } = useI18n()

	const { formatArea } = useFormatters()

	/**
	 *
	 * @param {object} field field object
	 * @param {object} overriddenParams
	 * @param {boolean} overriddenParams.showFactArea Is it necessary to show the fact area
	 * @param {string} overriddenParams.titleIfEmpty title if field is empty
	 * @returns {string} formatted title
	 */

	const getFieldTitle = (field, overriddenParams) => {
		if (!field || Object.keys(field).length === 0) return null

		const defaultParams = {
			showFactArea: true,
			titleIfEmpty: null,
		}

		const params = Object.assign(defaultParams, overriddenParams)

		const areasAttrsToAddingToTitle = []

		if (params.showFactArea) areasAttrsToAddingToTitle.push('fact_area')

		const canShowFewAreas = areasAttrsToAddingToTitle.length > 1

		let title = ''
		if (field.title) {
			title += field.title
		}

		if (canShowFewAreas) {
			title += ' ( '

			title += areasAttrsToAddingToTitle
				.map((numberAttr) => {
					if (field[numberAttr]) {
						return formatArea(field[numberAttr])
					}
				})
				.join(', ')

			title += ' )'
		} else {
			if (params.showFactArea && field?.fact_area) {
				title += ` (${formatArea(field.fact_area)})`
			}
		}
		return title || params.titleIfEmpty
	}

	const {
		loadEntityFlags: flags,

		entities: fullFields,
		getEntities: getFullFields,

		extendedEntities: extendedFields,
		getExtendedEntities: getExtendedFields,

		basedEntities: basedFields,
		getBasedEntities: getBasedFields,

		hashedBasedEntities: hashedBasedFields,
		getHashedBasedEntities: getHashedBasedFields,

		hashedExtendedEntities: hashedExtendedFields,
		getHashedExtendedEntities: getHashedExtendedFields,

		createEntity: createField,

		entity: field,
		getEntity: getField,

		entityPopup: popupField,
		getEntityPopup: getPopupField,

		entityPreview: previewField,
		getEntityPreview: getPreviewField,

		patchEntity: patchField,
		updateEntity: putField,

		deleteEntity: deleteField,
	} = useBlProviders(
		fieldsDt,
		Object.assign({
			postProcessEntityCallback: (field) => {
				field.__ao__title = getFieldTitle(field)
				return field
			},

			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Error loading fields!'),

			showErrorNotificationForCreatingEntity: true,

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,

			showErrorNotificationForDeletingEntity: true,
		}),
	)

	return {
		flags,
		fullFields,
		basedFields,
		extendedFields,
		previewField,
		popupField,
		field,

		getBasedFields,
		getExtendedFields,
		getFullFields,
		getPreviewField,
		getPopupField,
		getField,
		createField,
		putField,
		patchField,
		deleteField,

		hashedBasedFields,
		getHashedBasedFields,

		hashedExtendedFields,
		getHashedExtendedFields,
	}
}
